(function () {
  class GambleSpin extends PIXI.Container {
    constructor() {
      super();

      this._screenDim = undefined;

      this.visible = false;
      this._screenDimTargetAlpha = 0.6;

      this._takeSpinsButton = undefined;
      this._arrow = undefined;
      this._gambleButton = undefined;
      this._winAnim = undefined;
      this._touchToGamble = undefined;

      this._winStartAngle = undefined;
      this._winEndAngle = undefined;
      this.loseStartAngle = undefined;
      this._loseEndAngle = undefined;

      this._currentWin = false;

      this._possibleValues = undefined;
      this._localFSIndex = 0;

      this.emitter = undefined;

      this.winAnimPositions = [];

      let self = this;
      StateMachine.Create(this);
      Reflex.addToUpdate(function () {
        self.update();
      });

      this.stateMachine.addState("IDLE", function () {});
      this.stateMachine.addState("PULSE", function () {
        self.update_pulse();
      });
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    update() {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
    }

    update_pulse() {
      if (this.phase.once()) {
        this._touchToGamble.scale.x = 1.0;
        this._touchToGamble.scale.y = 1.0;

        this._touchToGamble.checkBounds(1.0);
      }

      if (this.phase.timed(4000)) {
        let newScale =
          1.0 + 0.1 * Math.abs(Math.sin(Math.PI * this.phase.Progress));
        this._touchToGamble.scale.x = newScale;
        this._touchToGamble.scale.y = newScale;

        this._touchToGamble.checkBounds(newScale);
      }

      if (this.phase.once()) {
        this.stateMachine.switchState("PULSE");
      }
    }

    onLayoutComplete() {
      this._takeSpinsButton = resourceManager.get(
        "gambleSpinContainer:GambleSpin:takeSpinsButton"
      );
      this._takeSpinsButton.mousedown = this._takeSpinsButton.touchstart =
        this.onClickedToContinue.bind(this);

      this._takeSpinsButtonText = resourceManager.get(
        "gambleSpinContainer:GambleSpin:takeSpinsButton:takeSpinsButtonText"
      );

      this._arrow = resourceManager.get(
        "gambleSpinContainer:GambleSpin:gambleArrow"
      );

      this._winAnim = resourceManager.get(
        "gambleSpinContainer:GambleSpin:currentSpinsContainer:burstAnim"
      );
      this._winAnim.gotoAndStop(0);

      this._currentFreeSpins = resourceManager.get(
        "gambleSpinContainer:GambleSpin:currentSpinsContainer:text"
      );

      this.setWinAnimPositions();

      this._gambleButton = resourceManager.get(
        "gambleSpinContainer:GambleSpin:gambleButton"
      );
      this._gambleButton.mousedown = this._gambleButton.touchstart =
        this.onCommittedToGamble.bind(this);

      this._winText = resourceManager.get(
        "gambleSpinContainer:GambleSpin:winText"
      );

      this._loseText = resourceManager.get(
        "gambleSpinContainer:GambleSpin:loseText"
      );

      this._winText.visible = false;
      this._loseText.visible = false;

      this.emitter = particleManager.createEmitter(
        "gambleDustEmitter",
        "gambleSpinContainer:GambleSpin:particlesContainer",
        0,
        0,
        false
      );
      this.emitter.particleEmitter.emit = false;

      messageBus.subscribe("Gamble:Risk", this.onGambleRisk.bind(this));
      messageBus.subscribe("Gamble:Collect", this.onGambleCollect.bind(this));

      Reflex.registerEventHandler(
        "orientationChange",
        this.setWinAnimPositions.bind(this)
      );
    }

    setWinAnimPositions() {
      this.winAnimPositions = [];
      this.winAnimPositions.push(this._currentFreeSpins.position.get());
    }

    onGambleCollect() {
      this._takeSpinsButton.interactive = false;
      this.alpha = 1;
      this.visible = false;

      this.stateMachine.switchState("IDLE");
    }

    onGambleRisk() {
      this._gambleButton.interactive = false;
      this._takeSpinsButton.interactive = false;

      this.emitter.particleEmitter.emit = false;

      soundManager.play("gambleSpin");
    }

    onCommittedToGamble() {
      messageBus.postImmediate("Gamble:Risk");
    }

    onClickedToContinue() {
      messageBus.postImmediate("Gamble:Collect");
      soundManager.play("buttonPressed");
    }

    setupWheel(winChance) {
      let loseChance = 1 - winChance;

      var graphics = resourceManager.get(
        "gambleSpinContainer:GambleSpin:gambleSegments"
      );
      graphics.clear();

      this._loseStartAngle = 0;
      this._loseEndAngle = loseChance * Math.PI * 2;

      this._winStartAngle = this._loseEndAngle;
      this._winEndAngle = this._loseEndAngle + winChance * Math.PI * 2;

      // Winning arc
      graphics.beginFill(0x00c800);
      graphics.lineStyle(0, 0xffffff);
      graphics.moveTo(0, 0);
      graphics.arc(0, 0, 90, this._winStartAngle, this._winEndAngle); // cx, cy, radius, startAngle, endAngle
      graphics.endFill();

      // Losing arc
      graphics.beginFill(0xc80000);
      graphics.lineStyle(0, 0xffffff);
      graphics.moveTo(0, 0);
      graphics.arc(0, 0, 90, this._loseStartAngle, this._loseEndAngle); // cx, cy, radius, startAngle, endAngle
      graphics.endFill();
    }

    resetGambleSpin(startPos) {
      this._localFSIndex = startPos;
    }

    start(winChance, possibleValues, firstEntry) {
      this.visible = true;
      this._takeSpinsButton.visible = true;
      this._gambleButton.visible = true;

      this._possibleValues = possibleValues;

      if (this._currentFreeSpins.text === "7") {
        this._currentFreeSpins.position.x = 5;
      }
      this._currentFreeSpins.text = this._possibleValues[this._localFSIndex];

      resourceManager.get("gambleIntroContainer:GambleIntro").visible = false;
      resourceManager.get(
        "gambleDisclaimerContainer:GambleDisclaimer"
      ).visible = false;
      resourceManager.get("gambleSpinContainer:GambleSpin").visible = true;

      this._takeSpinsButton.interactive = true;
      this._gambleButton.interactive = true;

      this.setupWheel(winChance);

      if (firstEntry) {
        this._arrow.rotation = Math.PI / 2;
      }

      this._takeSpinsButtonText.setTranslationParameters(
        this._possibleValues[this._localFSIndex]
      );

      messageBus.postImmediate("Gamble:WaitForInput");
    }

    spinToResult(result, callback) {
      this._currentWin = result;
      this._resultShownCb = callback;
      this._takeSpinsButton.visible = false;
      this._gambleButton.visible = false;

      let totalSpins = 5; // number of times to spin the wheel the full 360

      let spinAngle = undefined;
      let safetyAngle = 0.087; // ( now 5 degrees either side ) 0.02; // just over one degree ( in radians ) to prevent overlap into adjoining segment - may need increasing

      // Create a new instance of the RNG
      let rng = new gameController.RNG();

      if (this._currentWin) {
        spinAngle =
          this._winStartAngle +
          safetyAngle +
          rng.nextFloat() *
            (this._winEndAngle -
              safetyAngle -
              (this._winStartAngle + safetyAngle));
      } else {
        spinAngle =
          this._loseStartAngle +
          safetyAngle +
          rng.nextFloat() *
            (this._loseEndAngle -
              safetyAngle -
              (this._loseStartAngle + safetyAngle));
      }

      // NOTE: VERY VERY IMPORTANT - spin angle is in arc coordinates so 0 rad = 3pm, whereas the arrow sprite 0 rad = 12pm
      // arrow needs to land at spin angle + PI/2

      let totalSpinDistance =
        totalSpins * Math.PI * 2.0 + spinAngle + Math.PI / 2;
      let totalTime = 4000;
      let self = this;
      let baseArrowPos = 0;

      timerManager.addTimer(
        totalTime,
        function (progress) {
          var easedRotation =
            baseArrowPos +
            Math.sqrt(1 - Math.pow(progress - 1, 2)) * totalSpinDistance;

          self._arrow.rotation = easedRotation;

          if (progress > 0.08 && progress < 0.9) {
            self.emitter.particleEmitter.emit = true;

            var emitterAngle = easedRotation - Math.PI / 2;

            var xx = 130 * Math.cos(emitterAngle);
            var yy = 130 * Math.sin(emitterAngle);

            self.emitter.particleEmitter.spawnPos.x =
              self._arrow.position.x + xx;
            self.emitter.particleEmitter.spawnPos.y =
              self._arrow.position.y + yy;
          } else {
            self.emitter.particleEmitter.emit = false;
          }
        },
        function () {
          self.resultLanded();
        }
      );
    }

    resultLanded() {
      this._localFSIndex++;

      this.emitter.particleEmitter.emit = false;

      if (this._currentWin) {
        soundManager.play("gambleWin1");
        this._takeSpinsButtonText.setTranslationParameters(
          this._possibleValues[this._localFSIndex]
        );

        this._currentFreeSpins.position.x = 0;
        this._currentFreeSpins.text = this._possibleValues[this._localFSIndex];

        this._winAnim.gotoAndPlay(0);

        // soundManager.play("explode" + Math.floor(Math.random() * 3));

        this._winText.scale.x = 0;
        this._winText.scale.y = 0;

        this._winText.visible = true;

        gsap.to(this._winText.scale, {
          duration: 0.6,
          x: 1,
          y: 1,
          ease: "back.out(2)",
          yoyo: true,
          repeat: 1,
          repeatDelay: 0.4,
          onComplete: () => {
            this._winText.visible = true;
          },
        });
      } else {
        soundManager.play("gambleLose");
        this.stateMachine.switchState("IDLE");

        // this._loseText.scale.x = 0;
        // this._loseText.scale.y = 0;
        this._loseText.alpha = 0;

        this._loseText.visible = true;

        gsap.to(this._loseText, {
          duration: 0.25,
          alpha: 1,
          ease: "none",
        });
      }

      let self = this;
      timerManager.addTimer(
        2000,
        function () {},
        function () {
          if (self._currentWin) {
            if (this._localFSIndex < 2) {
              self._takeSpinsButton.visible = true;
            }
          } else {
            self._loseText.alpha = 0;
            self.visible = false;
          }

          self._resultShownCb();
        }
      );
    }
  }

  let gambleSpinCreator = function (json) {
    return new GambleSpin();
  };

  let gambleSpinInitialiser = function (json, disclaimer) {
    disclaimer.initialise();
  };

  let gambleSpinFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "GambleSpin",
    gambleSpinCreator,
    gambleSpinInitialiser,
    gambleSpinFilesRequired
  );
})();
